/**
 * Generate a random string.
 * Caution: This is not a cryptographically secure random number generator.
 * Do not use this function for anything security related.
 *
 * @returns {string} random string
 */
export function randomId() {
  return Math.random().toString(36).slice(2);
}
